import { useQuery } from "@tanstack/react-query";
import merchantUserService from "..";

const useGetMerchantUsers = () => {
  return useQuery({
    queryKey: ["getMerchantUsers"],
    queryFn: () => merchantUserService.getMerchantUsers(),
    select: (res) => res,
  });
};

export default useGetMerchantUsers;
